function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
class Token {
  constructor(options) {
    this.options = Object.assign({
      token: null,
      onBeforeExpire: () => {},
      onAfterExpire: () => {}
    }, options);
    if (this.options.token) {
      this.update(this.options.token, true);
    }
    this.after = null;
    this.before = null;
  }
  update(token, initial) {
    if (this.before) {
      clearTimeout(this.before);
    }
    if (this.after) {
      clearTimeout(this.after);
    }
    let _token$split = token.split('='),
      _token$split2 = _slicedToArray(_token$split, 3),
      meta = _token$split2[0],
      payload = _token$split2[1],
      signature = _token$split2[2];
    meta = JSON.parse(base32.parse(meta));
    let diff = null;
    if (meta.ttl) {
      let expires = Math.round(meta.created) + meta.ttl * 1000;
      diff = expires - new Date().getTime();
    }
    if (meta.payload == 'base32') {
      payload = JSON.parse(base32.parse(payload));
    } else {
      payload = null;
    }
    this.token = {
      valid: diff === null || diff > 0,
      token: token,
      meta: meta,
      payload: payload,
      signature: signature
    };

    /* Check for server/client time mismatch */

    if (!initial) {
      let age = 0 - Math.round((meta.created - new Date().getTime()) / 1000);
      if (Math.abs(age) > 60 * 15) {
        return;
      }
    }

    /* Check for token expiration */

    if (diff !== null) {
      let beforeExpiration = diff - 60 * 1000;
      if (beforeExpiration > 0) {
        this.before = setTimeout(() => {
          this.options.onBeforeExpire();
        }, beforeExpiration);
        this.after = setTimeout(() => {
          this.options.onAfterExpire();
        }, diff);
      } else if (diff > 0) {
        this.options.onBeforeExpire();
        this.after = setTimeout(() => {
          this.options.onAfterExpire();
        }, diff);
      } else {
        this.options.onAfterExpire();
      }
    }
  }
  get valid() {
    if (!this.token) {
      return false;
    }
    let meta = this.token.meta;
    if (!meta.ttl) {
      return true;
    }
    let expires = Math.round(meta.created) + meta.ttl * 1000;
    let diff = expires - new Date().getTime();
    return diff > 0;
  }
  get expires() {
    if (!this.token) {
      return null;
    }
    let meta = this.token.meta;
    let expires = Math.round(meta.created) + meta.ttl * 1000;
    let diff = expires - new Date().getTime();
    return Math.round(diff / 1000);
  }
  get ttl() {
    if (!this.token) {
      return null;
    }
    return this.token.meta.ttl;
  }
  get value() {
    if (!this.token) {
      return null;
    }
    return this.token.token;
  }
}
//# sourceMappingURL=token.js.map
